import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

interface UploadProps {
  isDragActive: boolean;
  refKey?: string;
  [key: string]: any;
  type?: 'error' | 'success' | 'default';
}

const dragActive = css`
  border-color: #166649;
`;

export const DropContainer = styled.div.attrs({
  className: 'dropzone',
})`
  width: 100%;
  border: 1px dashed #c4c4c4;
  border-radius: 5px;
  cursor: pointer;
  outline: none;

  transition: height 0.2s ease;

  ${(props: UploadProps): false | FlattenSimpleInterpolation =>
    props.isDragActive && dragActive}

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const messageColors = {
  default: '#979797',
  error: '#C71F37',
  success: '#166649',
};

export const UploadMessage = styled.p`
  display: flex;
  font-size: 16px;
  line-height: 24px;
  padding: 4rem 0rem;

  color: ${({ type }: UploadProps) => messageColors[type || 'default']};

  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    padding: 6rem 0rem;
  }
`;
